import { Portal } from "@mui/material";
import Loading from "./Loading";

export interface FullPageLoadingProps {
  progress?: number;
  open: boolean;
  onCancel?: () => void;
}

function FullPageLoading(props: FullPageLoadingProps) {
  return (
    <Portal container={document.body}>
      <div style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 10000,
        pointerEvents: props.open ? 'auto' : 'none',
        opacity: props.open ? 1 : 0,
        transition: 'opacity 0.1s ease-in-out'
      }}>
        <Loading
          open={props.open}
          progress={props.progress}
          onCancel={props.onCancel}
          height="100vh"
          width="100vw"
          top="0"
          left="0"
        />
      </div>
    </Portal>
  );
}

export default FullPageLoading;
